import { SET_DISABLE_LAUNCH_EVENTS, MARK_OFFER_AVAILABLE, MARK_OFFER_PROVIDED, SAVE_OFFER_DATA, REMOVE_OFFER_DATA, SET_LAUNCH_OFFERS_PARAMETER } from './actionTypes';

export const markOfferAvailable = (offer: string): { type: string; offer: string; value: boolean } => {
    return {
        type: MARK_OFFER_AVAILABLE,
        offer,
        value: true,
    };
};

export const markOfferProvided = (offer: string): { type: string; offer: string } => {
    return {
        type: MARK_OFFER_PROVIDED,
        offer,
    };
};

export const saveOfferData = (offer: string, data: string): { type: string; offer: string; data: string } => {
    return {
        type: SAVE_OFFER_DATA,
        offer,
        data,
    };
};

export const removeOfferData = (offerName: string): { type: string; offerName: string } => {
    return {
        type: REMOVE_OFFER_DATA,
        offerName,
    };
};

export const setLaunchOffersParameter = (offer: string): { type: string; offer: string } => {
    return {
        type: SET_LAUNCH_OFFERS_PARAMETER,
        offer,
    };
};

export interface SetDisableLaunchEvents{
    type: "SET_DISABLE_LAUNCH_EVENTS";
    payload: {
        value: boolean;
        stateLocation: string;
    };
}
export function setDisableLaunchEvents(disableLaunchEvents: boolean, stateLocation: string): SetDisableLaunchEvents
{
    return {
        type: "SET_DISABLE_LAUNCH_EVENTS",
        payload: {
            value: disableLaunchEvents,
            stateLocation: stateLocation,
        },
    };
}



// WEBPACK FOOTER //
// ./modules/launch-offers-post-message-handling/actions/actions.ts